import React, {useCallback, useEffect} from 'react';

import './_editUser.scss'

import {ADD, useToastContext} from "../../../components/Toast"
import {useRecoilState, useRecoilValue} from "recoil";
import {userFormState} from "../../../state/users_form";
import {grpcUserServiceSelector} from "../../../state/grpc";
import {Link, useNavigate, useParams} from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  ButtonSet,
  Column,
  Form,
  Grid, PasswordInput,
  TextArea,
  TextInput
} from "@carbon/react";

const EditUser = () => {
  const userService = useRecoilValue(grpcUserServiceSelector)
  const [{
    username,
    email,
    password,
    company,
    firstname,
    lastname,
    address,
    city,
    country,
    zipCode,
    biography,
    saving,
    loading,
    error
  }, setUserForm] = useRecoilState(userFormState);
  const {toastDispatch} = useToastContext();
  const navigate = useNavigate();
  const {userID} = useParams();

  const navigateToUsersList = useCallback(() => {
    navigate('/users/list')
  }, [navigate])

  useEffect(() => {
    if (userID === undefined) {
      setUserForm({
        username: '',
        email: '',
        password: '',
        company: '',
        firstname: '',
        lastname: '',
        address: '',
        city: '',
        country: '',
        zipCode: '',
        biography: '',
        loading: false,
        saving,
        error: ''
      })
      return
    }
    const req = new proto.api.GetUserRequest()
    req.setId(userID)
    userService.getUser(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setUserForm({
          username,
          email,
          password,
          company,
          firstname,
          lastname,
          address,
          city,
          country,
          zipCode,
          biography,
          loading: false,
          saving: false,
          error: err
        })
      } else {
        const user = resp.toObject().user
        setUserForm({
          username: user.username,
          email: user.email,
          password: '',
          company: user.company,
          firstname: user.firstname,
          lastname: user.lastname,
          address: user.address,
          city: user.city,
          country: user.country,
          zipCode: user.zipCode,
          biography: user.biography,
          loading: false,
          saving: false,
          error: ''
        })
      }
    })
    // eslint-disable-next-line
  }, [])

  const handleUserSave = (err, resp) => {
    if (err != null) {
      setUserForm({
        username,
        email,
        password,
        company,
        firstname,
        lastname,
        address,
        city,
        country,
        zipCode,
        biography,
        loading: false,
        saving: false,
        error: err
      })
      toastDispatch({
        type: ADD,
        payload: {
          title: "Operazione fallita",
          content: "Impossibile salvare l'operatore '" + username + "'",
          kind: "error"
        }
      })
    } else if (resp != null && resp.array.length > 0) {
      setUserForm({
        username,
        email,
        password,
        company,
        firstname,
        lastname,
        address,
        city,
        country,
        zipCode,
        biography,
        loading: false,
        saving: false,
        error: ''
      })
      navigateToUsersList()
      toastDispatch({
        type: ADD,
        payload: {
          title: "Operazione avvenuta con successo",
          content: "Operatore '" + username + "' salvato con successo",
          kind: "success"
        }
      })
    }
  }

  const onSubmit = (ev) => {
    ev.stopPropagation()
    const req = new proto.api.SaveUserRequest()
    const user = new proto.api.User()
    user.setId(userID)
    user.setUsername(username)
    user.setPassword(password)
    user.setEmail(email)
    user.setCompany(company)
    user.setFirstname(firstname)
    user.setLastname(lastname)
    user.setAddress(address)
    user.setCity(city)
    user.setCountry(country)
    user.setZipCode(zipCode)
    user.setBiography(biography)
    req.setUser(user)
    setUserForm({
      username,
      email,
      password,
      company,
      firstname,
      lastname,
      address,
      city,
      country,
      zipCode,
      biography,
      loading: false,
      saving: true,
      error: ''
    })
    if (userID === undefined) {
      userService.createUser(req, null, (err, resp) => {
        handleUserSave(err, resp)
      })
    } else {
      userService.updateUser(req, null, (err, resp) => {
        handleUserSave(err, resp)
      })
    }
  }

  return (
    <Grid fullWidth className="users-page">
      <Column lg={16} md={8} sm={4}>
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link to='/users/list'>Operatori</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                {userID !== undefined ? userID : "Nuovo operatore"}
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              {userID !== undefined ? "Modifica operatore " + userID : "Nuovo operatore"}
            </h1>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="users-edit-page__r1">
            <Form onSubmit={(ev) => onSubmit(ev)}>
              <TextInput
                id="user-username"
                labelText={"Username" + (userID === undefined ? "" : " (Non modificabile)")}
                placeholder="Username"
                disabled={userID !== undefined}
                style={{marginBottom: '1rem'}}
                value={username}
                type="text"
                onChange={ev => setUserForm({
                  username: ev.target.value,
                  email,
                  password,
                  company,
                  firstname,
                  lastname,
                  address,
                  city,
                  country,
                  zipCode,
                  biography,

                })}
              />
              <TextInput
                id="user-email"
                labelText="Indirizzo email"
                placeholder="Email"
                required={true}
                style={{marginBottom: '1rem'}}
                value={email}
                type="text"
                onChange={ev => setUserForm({
                  email: ev.target.value,
                  username,
                  password,
                  company,
                  firstname,
                  lastname,
                  address,
                  city,
                  country,
                  zipCode,
                  biography,

                })}
              />
              {
                userID === undefined &&
                <PasswordInput
                  id="user-password"
                  labelText="Password operatore"
                  required={true}
                  style={{marginBottom: '1rem'}}
                  value={password}
                  onChange={ev => setUserForm({
                    username,
                    email,
                    password: ev.target.value,
                    company,
                    firstname,
                    lastname,
                    address,
                    city,
                    country,
                    zipCode,
                    biography,

                  })}
                />
              }
              <TextInput
                id="user-company"
                labelText="Azienda"
                placeholder="Azienda"
                style={{marginBottom: '1rem'}}
                value={company}
                type="text"
                onChange={ev => setUserForm({
                  company: ev.target.value,
                  email,
                  username,
                  password,
                  firstname,
                  lastname,
                  address,
                  city,
                  country,
                  zipCode,
                  biography,

                })}
              />
              <TextInput
                id="user-firstname"
                labelText="Nome"
                placeholder="Nome"
                style={{marginBottom: '1rem'}}
                value={firstname}
                type="text"
                onChange={ev => setUserForm({
                  firstname: ev.target.value,
                  email,
                  username,
                  password,
                  company,
                  lastname,
                  address,
                  city,
                  country,
                  zipCode,
                  biography,

                })}
              />
              <TextInput
                id="user-lastname"
                labelText="Cognome"
                placeholder="Cognome"
                style={{marginBottom: '1rem'}}
                value={lastname}
                type="text"
                onChange={ev => setUserForm({
                  lastname: ev.target.value,
                  email,
                  username,
                  password,
                  company,
                  firstname,
                  address,
                  city,
                  country,
                  zipCode,
                  biography,

                })}
              />
              <TextInput
                id="user-address"
                labelText="Indirizzo"
                placeholder="Indirizzo"
                style={{marginBottom: '1rem'}}
                value={address}
                type="text"
                onChange={ev => setUserForm({
                  address: ev.target.value,
                  email,
                  username,
                  password,
                  company,
                  firstname,
                  lastname,
                  city,
                  country,
                  zipCode,
                  biography,

                })}
              />
              <TextInput
                id="user-city"
                labelText="Città"
                placeholder="Città"
                style={{marginBottom: '1rem'}}
                value={city}
                type="text"
                onChange={ev => setUserForm({
                  city: ev.target.value,
                  email,
                  username,
                  password,
                  company,
                  firstname,
                  lastname,
                  address,
                  country,
                  zipCode,
                  biography,

                })}
              />
              <TextInput
                id="user-country"
                labelText="Paese"
                placeholder="Paese"
                style={{marginBottom: '1rem'}}
                value={country}
                type="text"
                onChange={ev => setUserForm({
                  country: ev.target.value,
                  email,
                  username,
                  password,
                  company,
                  firstname,
                  lastname,
                  address,
                  city,
                  zipCode,
                  biography,

                })}
              />
              <TextInput
                id="user-zip-code"
                labelText="CAP"
                placeholder="CAP"
                style={{marginBottom: '1rem'}}
                value={zipCode}
                type="text"
                onChange={ev => setUserForm({
                  zipCode: ev.target.value,
                  email,
                  username,
                  password,
                  company,
                  firstname,
                  lastname,
                  address,
                  city,
                  country,
                  biography,

                })}
              />
              <TextArea
                id="user-biography"
                labelText="Biografia"
                placeholder="Biografia"
                style={{marginBottom: '1rem'}}
                value={biography}
                maxCount={500}
                onChange={ev => setUserForm({
                  biography: ev.target.value,
                  email,
                  username,
                  password,
                  company,
                  firstname,
                  lastname,
                  address,
                  city,
                  country,
                  zipCode,

                })}
              />
              <ButtonSet className="users-edit-page__r1-form-btn">
                <Button onClick={navigateToUsersList} kind="secondary">
                  Annulla
                </Button>
                <Button disabled={saving} type="submit" kind="primary">
                  {saving ? "Salvataggio in corso.." : "Salva"}
                </Button>
              </ButtonSet>
            </Form>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

export default EditUser